<nav>
  <ul>
    @for (route of routes; track route.name) {
    <li [routerLink]="route.link" [queryParamsHandling]="route.queryParamHandling || 'replace'"
      routerLinkActive="active" *dpqaRequirePermissions="route.requiredPermissions">
      <dpqa-icon [iconName]="route.icon" />
      <p>{{ route.name | translate }}</p>
    </li>
    }
  </ul>

  <div class="profile-about-container">
    <dpqa-profile />
    <nz-divider nzType="vertical" />
    <dpqa-about></dpqa-about>
  </div>
</nav>
